import { isCampaignOpen } from '~/service/activeCampaign'
import { Explainer } from '~/components/Explainer'
import { EmailSubscriber } from '~/components'
import { type FC } from 'react'
import SplitMTD from '~/components/SplitMTD'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { MytennightsTestId } from '@lib/testing'
import { type CharityCampaign, getCharityFromDonation, gmErrorMessage, ScrollHash, useCheckoutPlan } from '@shamaazi/mytennights'
import HeadingBG from '~/assets/Heading bg.png'
import NoCampaignLandingBG from '~/assets/Langing BG - No Campaign.png'

export const HomeContent: FC<{ nextPage: string }> = ({ nextPage }) => {
  const { chainCode } = useParams<{ chainCode?: string }>()
  const { plan, setPlan } = useCheckoutPlan()
  const { error: parentCharityError } = useQuery<CharityCampaign | '' | undefined, Error>(
    ['parentCharity', chainCode],
    async () => chainCode && await getCharityFromDonation(chainCode), {
      retry: 0,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        setPlan({ ...plan, chainCode: chainCode ?? '', chainCodeCharity: data })
      },
      onError: () => {
        setPlan({ ...plan, chainCode: '' })
      }
    })
  return <div>
    <div id={ScrollHash.mtdDonateNow} style={{ backgroundImage: isCampaignOpen() ? `url(${HeadingBG})` : `url(${NoCampaignLandingBG})` }} className="h-5/6 md:h-full bg-no-repeat bg-cover bg-center flex flex-col items-center p-10 md:px-2 md:py-6">
      <h1 className={'text-center text-mtd-secondary-4 text-mtd-h1 font-bold leading-10 md:mt-14'}>Never Miss The 10 Days of Dhul Hijjah</h1>
      {isCampaignOpen() && <GMErrorMessage error={parentCharityError} chainCode={chainCode}/>}
      {isCampaignOpen() && <SplitMTD nextPage={nextPage} />}
      {!isCampaignOpen() && <div className={'min-w-screen w-full py-2 flex flex-col items-center px-2'}>
        <p className='text-mtd-h3 text-mtd-black text-center'>Get a reminder to automate your donations next Hajj</p>
        <EmailSubscriber />
      </div>}
      <div className='mt-16 md:mt-12 self-center text-center text-mtd-h4 font-normal text-mtd-secondary-4'>"There are no days during which righteous deeds are more</div>
      <div className='self-center text-center text-mtd-h4 font-normal text-mtd-secondary-4'>beloved to Allah than these (first) ten days of Dhul- Hijjah."</div>
      <div className='mt-2 justify-center text-mtd-info font-normal text-mtd-secondary-3'>– Prophet Muhammad PBUH [Al-Bukhari]</div>
    </div>
    <Explainer/>
  </div>
}

const GMErrorMessage: FC<{ error: Error | null, chainCode?: string }> = ({ error, chainCode }) => {
  if (error && chainCode) return <p data-test-id={MytennightsTestId.givematchErrorMessage} className="mt-5 w-11/12 sm:w-3/4 rounded font-medium text-center text-mtn-red ">{gmErrorMessage}</p>
  return <></>
}
